import { render, staticRenderFns } from "./_item.vue?vue&type=template&id=8d3713b8"
import script from "./_item.vue?vue&type=script&lang=ts"
export * from "./_item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports